import React, { useContext } from "react";
import classNames from "classnames";
import PropTypes, { bool, node, func, string, instanceOf } from "prop-types";

import Image from "pages/_components/Image";
import { AccordionContext } from "./Accordion";

const AccordionItem = ({
    item,
    number,
    children,
    fitContent,
    buttonClassName,
    navigationListItemClassName,
    titleStyles,
    titleClasses,
    toggleAccordion,
}) => {
    const { itemOpen, expandAll, numberToExpand, onClick } = useContext(AccordionContext);
    const isActive = expandAll || itemOpen === number || numberToExpand === number;

    const handleClickAccordion = () => {
        if (typeof onClick === "function") {
            onClick(number);
        }
        if (typeof toggleAccordion === "function") {
            toggleAccordion();
        }
    };

    return (
        <li
            className={classNames("navigational-list-item", navigationListItemClassName, {
                "min-w-table-detail-echeq": !fitContent,
                open: isActive,
            })}>
            <button
                className={classNames("collapsable-button", buttonClassName, {
                    "collapse-open": isActive,
                })}
                type="button"
                onClick={handleClickAccordion}>
                <h2 style={titleStyles} className={titleClasses}>{item}</h2>
                <Image src="images/chevromRight.svg" className="svg-icon svg-caret icon-large" />
            </button>
            <div className="form-group accordion-item-content">
                <div className="form-group-control-list">{children}</div>
            </div>
        </li>
    );
};

AccordionItem.propTypes = {
    item: node.isRequired,
    children: node.isRequired,
    number: PropTypes.number.isRequired,
    fitContent: bool,
    toggleAccordion: func,
    buttonClassName: string,
    navigationListItemClassName: string,
    titleStyles: instanceOf(Object),
};

AccordionItem.defaultProps = {
    fitContent: false,
    toggleAccordion: null,
    buttonClassName: "",
    navigationListItemClassName: "",
    titleStyles: {},
};

export default AccordionItem;
